import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../../hooks/useVariantAction'
import { useHook } from '../../../lenteHooks'
import { CommandModalButton } from '../../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../../commandActions/types'
import { ChangeFundForm } from './ChangeFundForm'

export const ChangeFundCommand = (props: ActionButtonProps) => {
  const translate = useTranslate()

  const { tenantId, isinKey } = useHook('routing.general.useFundPricesParams')()
  const actions = useHook('mutators.unitlink.useChangeFundActions')({
    tenantId,
    isinKey,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="unitLink.ChangeFundCommandData"
      title={translate('fund.actions.update')}
      commandDataForm={ChangeFundForm}
      submit={submit}
      {...props}
    />
  )
}
